export default {
  getDeliveryAddress: (state) => state.deliveryAddress,
};
